/* eslint-disable no-useless-concat */
import { FETCH_EMPLOYEE_MATCHING } from './types';
import salomapi from '../apis';

export const fetchEmployeeMatching = (code) => async dispatch => {
    const response = await salomapi.get('/spf/employermatching' + `${code ? '?region=' + code : ''}`);
    dispatch({ type: FETCH_EMPLOYEE_MATCHING, payload: response.data })
}
